import {UserRoleLevel} from './dataEnum';

export const UserRoleIcons = [
  {key: 'Service', name: 'icon-Service'},
  {key: 'Administrator', name: 'icon-Admin'},
  {key: 'Regular User', name: 'icon-Regular-User'},
  {key: 'Operator', name: 'icon-fast-operator'},
  {key: 'Tessara', name: 'icon-Tessara-super-user'},
];

export const UserRoleInactiveIcon = {
  SERVICE: 'icon-Service-Inactive',
  ADMINISTRATOR: 'icon-Admin-Inactive',
  REGULAR_USER: 'icon-Regular-User-Inactive',
};

export const SideMenuRight = {
  USER_MANAGEMENT: 'sidemenu.account.userManagement',
  CHANGE_PASSWORD: 'sidemenu.account.changePassword',
  EXPLORER: 'sidemenu.explorer',
  RUNTIME: 'sidemenu.runtime',
  DISPENSE_REPORT_EXPLORER: 'sidemenu.dispenseReportExplorer',
  HARDWARE_SETTINGS: 'sidemenu.hardwareSettings',
  LABWARE_MANAGER: 'sidemenu.labwareManager',
  DOWNLOAD_LOG: 'sidemenu.hardwareSettings.downloadLog',
  SETUP_WIZARD: 'sidemenu.preparationWizard',
  AUTO_SAVE_PROTOCOL: 'sidemenu.autoSaveProtocol',
  TIPS_PICKUP_CALIBRATION: 'sidemenu.hardwareSettings.a1OffsetCalibration',
  AUTO_TRAY_CALIBRATION: 'sidemenu.hardwareSettings.autoTrayCalibration',
  HEAD_CHANNELS_CONFIG: 'sidemenu.hardwareSettings.headChannelsConfig',
  IDLE_HUMIDITY: 'sidemenu.hardwareSettings.idleHumidity',
  PLATE_RECOGNITION: 'sidemenu.hardwareSettings.plateRecognition',
  BACKUP_AND_RESTORE: 'sidemenu.help.backupAndRestore',
};

export const ModalAccountRight = {
  DISABLED_USERNAME: 'modal.account.disabled.username',
  DISABLED_PASSWORD: 'modal.account.disabled.password',
  DISABLED_CONFIRM_PASSWORD: 'modal.account.disabled.confirmPassword',
  DISABLED_NAME: 'modal.account.disabled.name',
  DISABLED_EMAIL: 'modal.account.disabled.email',
  DISABLED_ROLE: 'modal.account.disabled.role',
  DISABLED_ALL_FIELD: 'modal.account.disabled.allField',
  DISABLED_ACTIVITY: 'modal.account.disabled.accountActivity',
};

export const GroupNameRole = {
  [UserRoleLevel.SERVICE]: 'Service',
  [UserRoleLevel.ADMINISTRATOR]: 'Admin',
  [UserRoleLevel.USER]: 'RegularUser',
  [UserRoleLevel.OPERATOR]: 'Operator',
  [UserRoleLevel.TESSARA_SUPER_USER]: 'TessaraSuperUser',
};

export const GroupName = {
  SIDEMENU_CREATE_USER: 'sidemenu',
  SIDEMENU: 'sideMenu',
  MODAL_ACCOUNT: 'modal.account',
  BUTTON_PROTOCOL: 'button.protocol',
  MODAL_EDIT_ACCOUNT: 'modal.account.edit',
};
